module.exports = __webpack_public_path__ + "static/media/cart.29ca3293.svg";